import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const setupWorkingAnimations = (section, setActiveStep) => {
  if (!section) {
    return () => {};
  }

  const ctx = gsap.context(() => {
    const eyebrow = section.querySelector(".working-eyebrow");
    const title = section.querySelector(".working-main-title");
    const subtitle = section.querySelector(".working-subtitle");
    const visual = section.querySelector(".working-visual");
    const info = section.querySelector(".working-info");

    const elements = [eyebrow, title, subtitle, visual, info];

    // Initial hidden state
    gsap.set(elements, {
      opacity: 0,
      y: 40,
      scale: 0.98,
    });

    // Create a paused timeline for the animation
    const timeline = gsap.timeline({ paused: true });

    // Staggered entry animation
    timeline.to(elements, {
      opacity: 1,
      y: 0,
      scale: 1,
      duration: 0.85,
      stagger: 0.15,
      ease: "power3.out",
    });

    // Use IntersectionObserver to play/reverse timeline
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            timeline.play(); // Play entry animation
          } else {
            timeline.reverse(); // Play exit animation
          }
        });
      },
      {
        threshold: 0.15, // Trigger when 15% is visible
      }
    );

    observer.observe(section);

    // ==========================================
    // GSAP Pinned Scroll-driven Step Transitions
    // ==========================================
    let currentStep = 0;
    const deadZone = 0.04; 

    ScrollTrigger.create({
      trigger: section,
      start: "top 60px",
      end: "+=1200", 
      pin: true,
      pinSpacing: true,
      scrub: true,
      onUpdate: (self) => {
        const p = self.progress; // 0 to 1

        let newStep = currentStep;

        // Define the valid range for the current step including the dead-zone
        const currentMin = (currentStep * 0.2) - deadZone;
        const currentMax = ((currentStep + 1) * 0.2) + deadZone;

        // If progress moves outside the current step's dead-zone range, calculate the new absolute step
        if (p < currentMin || p > currentMax) {
          if (p >= 0.8) newStep = 4;
          else if (p >= 0.6) newStep = 3;
          else if (p >= 0.4) newStep = 2;
          else if (p >= 0.2) newStep = 1;
          else newStep = 0;
        }

        if (newStep !== currentStep) {
          currentStep = newStep;
          if (setActiveStep) {
            setActiveStep(currentStep);
          }
        }
      },
    });

    return () => {
      observer.disconnect();
    };
  }, section);

  return () => {
    ctx.revert();
  };
};